import { type ReactNode } from 'react';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';

type MobileHeaderMenuItemProps = {
  onClick: () => void;
  title: string;
  renderIcon?: () => ReactNode;
  disabled?: boolean;
  dataTestId?: string;
};

const MobileHeaderMenuItem = ({ onClick, renderIcon, disabled, title, dataTestId }: MobileHeaderMenuItemProps) => {
  return (
    <MenuItem onClick={onClick} disabled={disabled} data-testid={dataTestId}>
      {renderIcon && <ListItemIcon>{renderIcon()}</ListItemIcon>}
      <ListItemText>{title}</ListItemText>
    </MenuItem>
  );
};

export { MobileHeaderMenuItem };
